import { MetaData } from '../types';

interface ApiResponse {
  isLoading: boolean;
  error?: string;
  data?: {
    data?: Array<any>;
    metadata: MetaData;
  };
}

const defaultData = [] as Array<any>;

const defaultMetaData = {
  total: 0,
  offset: 0,
  limit: 0,
};

export const formatApiResult = (res: ApiResponse, refetch?: () => void, setData?: () => void) => {
  return {
    error: res.error,
    state: res.isLoading ? 'loading' : res.error ? 'error' : 'success',
    isLoading: res.isLoading,
    data: (res?.data?.data || defaultData) as any,
    refetch,
    setData,
    metadata: res?.data?.metadata || defaultMetaData,
  };
};
